<style lang="stylus">
    .floatTitle-lockbox
        position absolute
        left 0
        top 0
        z-index 10

        .floatTitle-box
            max-width 400px
            width: max-content;
            border-radius $ft-boxradius
            box-shadow $ft-boxshadow
            cursor default
            user-select none
            pointer-events auto

            .editor-topbar
                width auto
                height 32px
                border-bottom 1px solid var(--border-color-float-hv-line)
                background-color $ft-bgcolor
                border-top-left-radius $ft-boxradius
                border-top-right-radius $ft-boxradius

                .topbar-title
                    float left
                    margin-left 16px
                    line-height 32px
                    color var(--text-color-primary)
                    font-weight 700
                    width calc(100% - 50px)
                    text-overflow ellipsis
                    white-space nowrap
                    overflow hidden

                .topbar-locked
                    float right
                    width 16px
                    height 16px
                    margin 8px
                    cursor pointer
                    border-radius 3px

                    .fix-icon,.item-icon
                        width 16px
                        height 16px
                        color var(--svg-color-gray-42-secondary)

                    &:hover
                        .item-icon
                            color var(--svg-color-black)

            .editor-topbar.active
                cursor move

            .ft-fillcolor
                padding-top 10px

            .palette
                display block
                position initial
                box-shadow none
            .ft-imgBorder
                border-top-left-radius 0
                border-top-right-radius 0
        .floatTool-cover
            position absolute
            left 0
            top 0
            width 100%
            height 100%
            z-index 1

        .floatTool-ban
            background rgba(255,255,255,.6)
            cursor not-allowed
</style>

<template>
    <div ref="dragbox" class="floatTitle-lockbox" :style="activeFloat ? 'z-index: 20' : ''" @click="clickModal" @mousedown="setActive">
        <div class="floatTitle-box" :class="{ active: dragActive }">
            <div ref="dragItem" class="editor-topbar" :class="{ active: dragActive }">
                <p class="topbar-title">{{ dragTitle }}</p>
                <div class="topbar-locked" v-if="!dragActive" @mousedown.stop @click="lockModal()">
                    <iconSymbol class="fix-icon" name="lockNail"></iconSymbol>
                </div>
                <div class="topbar-locked" v-if="dragActive" @mousedown.stop @click="closeModal()">
                    <iconSymbol class="item-icon" name="Del"></iconSymbol>
                </div>
            </div>
            <slot></slot>
        </div>
        <div class="floatTool-cover floatTool-ban" v-if="banTool"></div>
        <div class="floatTool-cover" v-show="!show"></div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
    import dragTool from "./dragTool";

    @Component({})
    export default class LockTitle extends Mixins(dragTool) {
        @Prop() name: string;
        @Prop() dragTitle: string;
        @Prop() show: boolean;

        moveActive = false;

        get lockIcon() {
            return this.dragActive ? "float-lock-active" : "float-lock";
        }

        setMoveStatus(status) {
            this.moveActive = status;
        }

        getDragElement() {
            return this.$refs.dragItem as HTMLElement;
        }

        clickModal() {
            this.$emit("clickModal");
        }

        lockModal() {
            this.dragActive = true;
            this.$emit("lockModal");
        }

        closeModal() {
            this.dragActive = false;
            this.$emit("closeModal");
        }

        get activeFloat() {
            return this.$store.state.floatTool.activeFloat == this.name;
        }

        setActive() {
            console.log("tool active");
            this.$store.commit("setFloatToolState", {
                activeFloat: this.name,
            });
        }

        initPosition(obj) {
            // showbox 前需调用，更新弹出窗口位置
            this.updatePosition(this.moveElement, obj.x, obj.y);
        }

        get dragSymbolToPage() {
            return this.$store.state.library.dragSymbolToPage;
        }

        get banTool() {
            return this.dragSymbolToPage;
        }

        mounted() {
            this.dragElement = this.getDragElement();
            this.moveElement = this.$refs.dragbox as HTMLElement;
            this.drag(this.dragElement, this.moveElement);
        }
    }
</script>
